export default {
    404: {
        "oops": "不好意思!",
        "error_message": "您要查找的页面当前不可用。错误代码：404",
        "go_back": "回到主页面",
    }
};
